import TimeValue from '../../../../modules/TimeValue.js';

class TimeAndTimelinePosition {
  static name = 'TimeAndTimelinePosition';

  constructor(time = TimeValue.zero, snappedTime = TimeValue.zero, timelinePosition = 0) {
    this.time = time;
    this.snappedTime = snappedTime;
    this.timelinePosition = timelinePosition;
  }

  static epsilonTimeMsec = TimeValue.msec(0.001);
  static epsilonTimelinePosition = 0.01;

  isEqualTo(that) {
    let differenceTime = that.time.getOffsetFrom(this.time).absolute();
    let differenceTimelinePosition = Math.abs(that.timelinePosition - this.timelinePosition);
    return differenceTime.isLessThan(TimeAndTimelinePosition.epsilonTimeMsec) && (differenceTimelinePosition < TimeAndTimelinePosition.epsilonTimelinePosition);
  }
}

export default TimeAndTimelinePosition;
